export default "__VITE_ASSET__0fcd023c__"